import {
    BookableServiceData,
    ProductChargingMode,
    ProductPostingMode,
    TimeUnitPeriod,
} from '@mews-commander/data-access';
import { DurationUtils, matchTimeUnitKey, useLocalizeText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

export const useLocalizeChargingMode = (bookableServiceData: BookableServiceData) => {
    const timeUnitTextKey = matchTimeUnitKey({
        perTimeUnit: true,
        timeUnit: bookableServiceData.timeUnitPeriod,
        isServiceDayUse:
            bookableServiceData.timeUnitPeriod === TimeUnitPeriod.Day &&
            !DurationUtils.isOverlappingNextTimeUnit(bookableServiceData.endOffset),
    }) as Mews.TextKey;

    const localizeText = useLocalizeText();
    const localizedTimeUnit = localizeText({
        textKey: timeUnitTextKey,
    });

    return (chargingMode: ProductChargingMode | ProductPostingMode) => {
        switch (chargingMode) {
            case ProductChargingMode.Once:
                return localizeText({ textKey: TextKey.ProductChargingOnce });
            case ProductChargingMode.PerTimeUnit || ProductPostingMode.PerTimeUnit:
                return localizeText({
                    textKey: timeUnitTextKey,
                    substitutes: { timeUnit: localizedTimeUnit },
                });
            case ProductChargingMode.PerPersonPerTimeUnit:
                return localizeText({
                    textKey: TextKey.PerPersonPerTimeUnit,
                    substitutes: { timeUnit: localizedTimeUnit },
                });
            case ProductChargingMode.PerPerson:
                return localizeText({ textKey: TextKey.ProductChargingPerPerson });
            default:
                return localizeText({ textKey: TextKey.ProductPostingModeOnce });
        }
    };
};

interface Props {
    bookableServiceData: BookableServiceData;
    charging: ProductChargingMode | ProductPostingMode;
}
export const LocalizedChargingMode = ({ bookableServiceData, charging }: Props) => {
    const localizeChargingMode = useLocalizeChargingMode(bookableServiceData);
    return <>{localizeChargingMode(charging)}</>;
};
